var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadComplete)?_c('div',{staticClass:"main"},_vm._l((_vm.activeModules),function(drillModule){return _c(drillModule,_vm._b({tag:"component"},'component',drillModule === 'Correct' ? { sortNum: _vm.sortNum } : {},false))}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }